import { api } from '../api';
import { getDeviceId } from './posStation';

// One hold session per iPad so Station 1's cart does not steal Station 2's.
export function getPosStockSessionId() {
  return `pos:${getDeviceId()}`.slice(0, 120);
}

function firstResult(res, menuItemId) {
  const rows = Array.isArray(res?.results) ? res.results : [];
  return rows.find((r) => Number(r.menu_item_id) === Number(menuItemId)) || rows[0] || null;
}

export async function reservePosStock(menuItemId, quantity) {
  const qty = Number(quantity) || 0;
  if (!menuItemId || qty <= 0) return { reserved: true, available: null };
  try {
    const res = await api.reserveStock(getPosStockSessionId(), [
      { menu_item_id: menuItemId, quantity: qty },
    ]);
    const row = firstResult(res, menuItemId);
    if (row && row.reserved === false) {
      return { reserved: false, available: Number(row.available) || 0 };
    }
    return { reserved: true, available: null };
  } catch {
    // Same fail-open as the customer app if the hold API is unreachable.
    // Sale-time stock deduct still stops a double sell.
    return { reserved: true, available: null };
  }
}

export function releasePosStock(menuItemId, quantity) {
  const qty = Number(quantity) || 0;
  if (!menuItemId || qty <= 0) return;
  void api.releaseStock(getPosStockSessionId(), [
    { menu_item_id: menuItemId, quantity: qty },
  ]).catch(() => {});
}

export function releaseAllPosStock() {
  void api.releaseStock(getPosStockSessionId()).catch(() => {});
}

export function touchPosStock() {
  void api.touchStockReservations(getPosStockSessionId()).catch(() => {});
}

export function stockHoldRefusedMessage(itemName, available) {
  const left = Number(available);
  if (Number.isFinite(left) && left > 0) {
    return `${itemName} — only ${left} left (held on another cart).`;
  }
  return `${itemName} is held on another cart or sold out.`;
}
